<template>
	<b-row>
		<b-col cols="12">
			<div id="parentx">
				<transition name="slide">
					<b-card>
						<div slot="header">
							{{ $t('transaction.transactions') }}
							<div class="card-header-actions">
								<b-link
									@click="newTrans(null, 'create')"
									class="card-header-action btn-setting"
									style="font-size: 15px"
									v-if="$can('create', 'item')"
								>
									<i class="fa fa-plus-circle"></i>
								</b-link>


							</div>
						</div>
						<b-card-body>

							<!-- TABLE -->
							<div class="table-responsive table-wrapper">
								<b-table
									striped
									hover
									:items="items"
									:fields="refField"
									:current-page="search.limit"
									:per-page="0"
									bordered="bordered"
									show-empty
									class="generalTableClass"
								>

									<template slot="actions" slot-scope="data">
										<b-link
											@click="openCreate(data.item, 'edit')"
											:title="$t('Edit')"
											v-if="$can('edit', 'item')"

										>
											<i class="fa fa-edit"></i>
										</b-link>
										<b-link :key="data.item.id + 'delete'"
												@click="closeOthers(data.item.id)"
												:id="'popOverDelete'+data.item.id"
												v-if="$can('delete', 'item')"
										>
											<i class="fa fa-trash"></i>
										</b-link>
										<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
										<b-popover
											:key="data.item.id + 'popover'"
											:target="'popOverDelete'+data.item.id"
											placement="auto"
											container="myContainer"
											:ref="'popover'+data.item.id"
											class="refDeleteConfirm"
										>
											<template slot="title">
												<b-button @click="onClose(data.item.id)" class="close"
														  aria-label="Close"
														  style="margin-left: 5px">
													<span class="d-inline-block" aria-hidden="true">&times;</span>
												</b-button>
												{{ $t('actions.deletetitle') }}
											</template>

											<div>
												<!--<b-link @click="onClose" size="sm" variant="danger">Yo'q</b-link>
                                                <b-link @click="onOk" size="sm" variant="primary">Ha</b-link>-->
												<div class="row mt-1">
													<div class="col-6">
														<b-button variant="outline-danger" size="sm" block
																  @click="deletePopover(data.item.id)">
															{{ $t('actions.no') }}
														</b-button>
													</div>
													<div class="col-6">
														<b-button variant="outline-success" size="sm" block
																  @click="remove(data.item.id)">{{ $t('actions.yes') }}
														</b-button>
													</div>
												</div>
											</div>
										</b-popover>
										<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->

									</template>

								</b-table>
								<div v-if="loader" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</div>
							<!-- TABLE -->


							<nav>
								<b-pagination :total-rows="total" :per-page="search.limit" v-model="search.page"
											  :prev-text="$t('pagination.prev')"
											  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
							</nav>

						</b-card-body>
					</b-card>
				</transition>
				<vs-sidebar :click-not-close="true" position-right parent="body" default-index="1" color="primary"
							class="create-modal" spacer v-model="newTransaction">
					<b-container index="1" v-if="newTransaction">
						<add-transaction @success="reloadList()"
										 @not-close="closable = $event"
										 @close="close"
										 :mode="mode"
										 :edit="item"
						></add-transaction>
					</b-container>
				</vs-sidebar>
			</div>
		</b-col>
	</b-row>
</template>

<script>

import AddTransaction from './blocks/AddTransaction'
import {mapActions, mapGetters} from "vuex";

export default {
	name: 'Transactions',

	data: () => {
		return {
			mode: 'create',
			item: null,
			loader: true,
			refField: [],
			newTransaction: false,
			search: {
				page: 1,
				limit: 20,
				attributes: []
			},
			dropdowns: {
				counterparties: [],
				contract_stage: [],
				responsiblelIds: [],
				responsiblelNames: [],
				contractIds: [],
				contragentNames: [],

			},
		};
	},


	/**
	 * Computed
	 */
	created() {
		this.allTransactions(this.search)
		this.refField = this.filterColumns(this.columns)
		this.loader = false
	},
	computed: mapGetters('transaction', {
		items: 'getAllTransactions',
		columns: 'columns',
		total: 'getTotal'
	}),

	methods: {
		...mapActions('transaction', ['allTransactions', 'deleteTransaction']),

		// Close new promo modal
		close() {
			this.newTransaction = false;
			this.mode = 'create';
			this.item = null;
		},
		filterColumns(columns = []) {
			return columns.filter(column => {
				if (column.visible) {
					column.label = this.$t(column.label);
					return column
				}
			})
		},
		openCreate(item = null, mode = 'create') {
			this.item = item
			this.mode = mode;
			setTimeout(() => {
				this.newTransaction = true
			}, 100);
		},
		onClose(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('close')
		},


		newTrans(item = null, mode = 'create') {
			this.item = item;
			this.mode = mode;
			setTimeout(() => {
				this.newTransaction = true
			}, 100);
		},

		reloadList() {
			setTimeout(() => {
				this.allTransactions(this.search)
			}, 200);
			this.newTransaction = false;

		},
		deletePopover(index) {
			const refName = `popover${index}`;
			this.$refs[refName].$emit('close')
		},
		closeOthers(id) {
			Object.keys(this.$refs).map(key => {
				if (key !== `popover${id}`) {
					const refName = `popover${id}`;
					this.$refs[refName].$emit('close')
				}
			});
		},
		remove(id) {
			this.deleteTransaction(id)
			this.reloadList();
		},
	},


	mounted() {
	},

	watch: {
		'search.page': {
			handler() {
				this.allTransactions(this.search)
			}
		},
	},
	/**
	 * components
	 */
	components: {
		AddTransaction
	},


}
</script>

<style scoped>
.table-wrapper {
	position: relative;
	padding: 5px;
}

.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}
</style>
